// extracted by mini-css-extract-plugin
module.exports = {"menu":"Slider_menu__S2BJn","link":"Slider_link__EBKwK","search":"Slider_search__2JJuo","slider":"Slider_slider__1z_5u"};